<template>
  <div :class="['common-dialog-box', className]">
    <v-touch
      tag="div"
      class="dialog-mask"
      @touchmove.prevent
      @tap="handleClose({ isMask: 1 })"
    ></v-touch>

    <div class="dialog-cont">
      <v-touch
        class="dialog-close"
        tag="span"
        @tap="handleClose"
        v-if="showClose"
      >
      </v-touch>

      <p v-if="title" class="txt" v-html="title">title</p>
      <slot v-else />
      <div class="opt-group">
        <v-touch
          tag="span"
          class="btn"
          v-for="(v, index) in buttons"
          :key="index"
          @tap="handleClick({ index: index })"
          :style="
            index === buttons.length - 1
              ? {
                  color: theme,
                  borderColor: theme
                }
              : {}
          "
        >
          {{ v.label }}
        </v-touch>
      </div>
    </div>
  </div>
</template>

<script>
// <Dialog
//   title="是否开始接单？"
//   v-if="dialogVisable"
//   :buttons="[{
//     label: '取消'
//   },
//   {
//     label: '确定',
//     onClick: function(){
//       console.log(1)
//     }
//   }]"
//   @close="dialogVisable = false"
// />
const defaultBtns = [
  {
    label: '取消',
    onClick: () => {}
  },
  {
    label: '确定',
    onClick: () => {}
  }
]
export default {
  name: 'Dialog',
  props: {
    title: {
      type: String
    },
    buttons: {
      type: Array,
      default() {
        return defaultBtns
      }
    },
    theme: {
      type: String,
      default: '#ff745b'
    },
    showClose: {
      type: Boolean,
      default: false
    },
    maskClose: {
      type: Boolean,
      default: false
    },
    className: {
      type: String,
      default: ''
    }
  },

  methods: {
    handleClick(obj) {
      this.clickTimer = setTimeout(() => {
        const { index } = obj
        const close = () => this.$emit('close', this.buttons[index], index)
        let result = true
        //对应button的回调执行
        if (typeof this.buttons[index].onClick === 'function') {
          let _result = this.buttons[index].onClick(close)
          result = _result === false ? false : true
        }
        console.log('result', result)

        if (result) {
          close()
        }
      }, 100)
    },
    handleClose({ isMask }) {
      this.clickTimer = setTimeout(() => {
        if (isMask) {
          if (this.maskClose) {
            this.$emit('close')
          }
        } else {
          this.$emit('close')
        }
      }, 100)
    }
  },
  destroyed() {
    clearTimeout(this.clickTimer)
  }
}
</script>

<style lang="scss" scoped>
@import '../assets/sass/config';
@import '../assets/sass/function';
@import '../assets/sass/mixin';
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.common-dialog-box {
  .dialog-mask {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.3);
    z-index: 12;
  }
  .dialog-cont {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    box-sizing: border-box;
    width: pxToRem(560);
    padding: pxToRem(50) pxToRem(15);
    background-color: #fff;
    border-radius: pxToRem(20);
    z-index: 12;
    &.move-up {
      animation: moveUpWechat 0.3s ease-out forwards;
    }
    &.move-down {
      animation: moveDownWechat 0.3s ease-out forwards;
    }
    .dialog-close {
      position: absolute;
      right: 50%;
      margin-right: pxToRem(-40);
      bottom: pxToRem(-120);
      color: #c1c1c1;
      display: block;
      background: url('../assets/images/qingsu/bg-model-close-btn.png')
        no-repeat center;
      background-size: cover;
      width: pxToRem(80);
      height: pxToRem(80);
    }
    .txt {
      padding: 0 pxToRem(15);
      // @include font-dpr(14px);
      font-size: pxToRem(28);
      color: #333;
      line-height: pxToRem(48);
      text-align: center;
    }
    .opt-group {
      margin-top: pxToRem(47);
      padding: 0 pxToRem(25);
      display: flex;
      justify-content: space-between;
      .btn {
        margin: 0 pxToRem(25);
        flex: 1;
        height: pxToRem(68);
        line-height: pxToRem(68);
        text-align: center;
        border-radius: pxToRem(15);
        @include font-dpr(14px);
        border: 1px solid #999;
        color: #999;
        &:nth-last-child(1) {
          border: 1px solid #ff745b;
          color: #ff745b;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// Dialog.vue?939fc3e2